import MyAccount from './MyAccount';
new MyAccount();